import { configureStore } from "@reduxjs/toolkit";

import contact from "./slices/contact.slice";
import sets from "./slices/sets.slice";
import services from "./slices/services.slice";
import employee from "./slices/employee.slice";

export const store = configureStore({
  reducer: {
    contact,
    sets,
    services,
    employee,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== "production",
});
